import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import VehicleHireTemplateTable from './VehicleHireTemplateTable';
const Page = () => {
    return (_jsx("div", { className: "container-fluid", children: _jsx(VehicleHireTemplateTable, {}) }));
};
export default Page;
